<template>
  <div>
    <div class="relative pt-4 bg-white rounded-lg">
      <h4 class="text-xl font-semibold text-center">
        {{ $t('referrals.social_shop_ricoma.modal_text') }}
      </h4>
      <span
        class="absolute top-0 right-0 block p-1 mt-4 ml-auto mr-4 rounded-full cursor-pointer bg-ricoma-gray-300 text-ricoma-gray-500"
        @click="$emit('close')"
      >
        <VSvgIcon name="close" />
      </span>
      <div class="p-8">
        <div v-for="productEligible in productsEligible" v-bind:key="productEligible.group_name">
          <div class="py-2 px-4 font-bold text-white bg-black">
            {{ productEligible.group_name }}
          </div>
          <div class="py-4 bg-gray-100">
            <div
              class="py-2"
              v-for="product in productEligible.products"
              v-bind:key="product.display_name"
            >
              <div class="flex px-4">
                {{ product.display_name }}
                <a
                  :href="product.external_shopify_link"
                  class="ml-1 cursor-pointer"
                  target="_blank"
                >
                  <VSvgIcon name="openInNew" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VSvgIcon from '@/components/base/VSvgIcon';

export default {
  name: 'ReferralProductsEligible',
  components: { VSvgIcon },
  props: {
    productsEligible: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>
